<script setup lang="ts">
  import { useLoginStore } from '@/store/login.store.ts'
  import { useRouter } from 'vue-router'
  import { onMounted, onUnmounted, ref } from 'vue'

  const loginStore = useLoginStore()
  const router = useRouter()

  const dots = ref<string>('')
  let interval: number | undefined = undefined

  async function processSsoLogin() {
    await loginStore.processSsoLogin()

    await router.push('/')
  }

  onMounted(async () => {
    void processSsoLogin()
    interval = window.setInterval(() => {
      dots.value = dots.value.length >= 3 ? '' : dots.value + '.'
    }, 500)
  })

  onUnmounted(async () => {
    clearInterval(interval)
  })
</script>

<template>
  <div class="container">
    <h1 class="title">SSO login verwerken{{ dots }}</h1>
  </div>
</template>

<style scoped>
  .container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
  }
  .title {
    text-align: center;
  }
</style>
